import React, { RefObject, JSX } from 'react';
import { useLocalStore } from 'mobx-react';
import useAppService from '../../Hooks/useAppService';
import { useTheme } from '@emotion/react';
import PackageSearchParams from '../PackageSearch/PackageSearchParams';
import BestPriceAvailabilitySearchStore from './BestPriceAvailabilitySearchStore';
import PackageDropdownFilterRenderer, { PackageCode } from './PackageDropdownFilterRenderer';
import { DateRangeInputSingleFieldRefType } from '../../Components/Input/DateRangeInputSingleField/DateRangeInputSingleField';

const PackageDropdownFilter = <T,>({
  onChange,
  initialSearchParams,
  datepickerMaxDate,
  datepickerMinDate,
  origins,
  ownArrivalsAndDepartures,
  disabled,
  defaultDate,
  dateRangeRef,
  onToggle,
  numberOfTravelers,
  memoDeps,
  showNumberSelector,
  isBusPackage,
  packageCodes
}: {
  onChange: (searchParams: Partial<PackageSearchParams>) => void;
  initialSearchParams?: Partial<PackageSearchParams>;
  datepickerMinDate?: string;
  datepickerMaxDate?: string;
  origins: string[];
  ownArrivalsAndDepartures?: boolean;
  disabled?: boolean;
  defaultDate?: {
    startDate?: string;
    endDate?: string;
  };
  dateRangeRef?: RefObject<DateRangeInputSingleFieldRefType>;
  onToggle?: {
    calendar?: (a: { isOpen?: boolean; startDate?: Date; endDate?: Date }) => void;
  };
  numberOfTravelers?: number;
  memoDeps?: T[];
  showNumberSelector?: boolean;
  isBusPackage?: boolean;
  packageCodes?: PackageCode[];
}): JSX.Element => {
  const app = useAppService();
  const theme = useTheme();
  const searchStore = useLocalStore(
    () => new BestPriceAvailabilitySearchStore(app.config, theme, true, initialSearchParams)
  );

  return (
    <PackageDropdownFilterRenderer
      packageCodes={packageCodes}
      store={searchStore}
      onChange={onChange}
      datepickerMaxDate={datepickerMaxDate}
      datepickerMinDate={datepickerMinDate}
      origins={origins}
      ownArrivalsAndDepartures={ownArrivalsAndDepartures}
      disabled={disabled}
      defaultDate={defaultDate}
      dateRangeRef={dateRangeRef}
      onToggle={onToggle}
      numberOfTravelers={numberOfTravelers}
      memoDeps={memoDeps}
      showNumberSelector={showNumberSelector}
      isBusPackage={isBusPackage}
    />
  );
};

export default PackageDropdownFilter;
